module.exports = __webpack_public_path__ + "static/media/slideshow (5).3c25dba4.png";